import { css } from '@emotion/react';
import { IColors } from 'types/colors';

export const warningLineCss = (colors: IColors, withMargin: boolean) => css`
	color: ${colors.tx_error};
	font-size: 1.4rem;
	text-align: center;
	${!withMargin && 'margin: 0;'}
`;

interface IProps {
	colors: IColors;
	error?: string | null;
	withMargin?: boolean;
}

export const ErrorText = ({ colors, error = null, withMargin = true }: IProps) => {
	return <p css={warningLineCss(colors, withMargin)}>{error}</p>;
};
